import api from "./api";

const request = async (operation) => {
  try {
    const response = await operation();
    if (!response.data?.success) throw response.data;
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error || { message: "Unable to load reports" };
  }
};

export const getReports = (params, signal) =>
  request(() => api.get("admin/reports", { params, signal }));
export const getReport = (id, signal) =>
  request(() => api.get(`admin/reports/${id}`, { signal }));
export const reviewReport = (id, data) =>
  request(() => api.patch(`admin/reports/${id}`, data));
